import React from 'react';
import ContentLoader from 'react-content-loader';

const ReserveSeatsCardSkeleton: React.FC<{}> = () => (
  <div className="w-full h-full flex flex-col rounded-lg shadow-md overflow-hidden">
    <div className="p-[12px] sm:py-[16px] sm:px-[24px] bg-neutral-20 border-b border-neutral-40">
      <ContentLoader
        width="100%"
        height={77}
        backgroundColor="rgba(0,0,0,0.06)"
        foregroundColor="rgba(0,0,0,0.18)"
      >
        <rect
          x="0"
          y="0"
          rx="8"
          ry="8"
          width="100%"
          height="100%"
          className="m-[16px]"
        />
      </ContentLoader>
    </div>
    <div className="p-[12px] sm:p-[24px] border-b border-neutral-40">
      <ContentLoader
        width="100%"
        height={64}
        backgroundColor="rgba(0,0,0,0.06)"
        foregroundColor="rgba(0,0,0,0.18)"
      >
        <rect
          x="0"
          y="0"
          rx="8"
          ry="8"
          width="70"
          height="20"
          className="mb-[4px]"
        />
        <rect x="0" y="24" rx="8" ry="8" width="100%" height="39" />
      </ContentLoader>
    </div>
    <div className="p-[12px] sm:px-[24px] border-b border-neutral-40">
      <ContentLoader
        width="100%"
        height={52}
        backgroundColor="rgba(0,0,0,0.06)"
        foregroundColor="rgba(0,0,0,0.18)"
      >
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="52" />
      </ContentLoader>
    </div>
    <div className="p-[12px] sm:py-[16px] sm:px-[24px] border-b border-neutral-40 mt-auto">
      <div className="w-[112px] ml-auto">
        <ContentLoader
          width="100%"
          height={36}
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.18)"
        >
          <rect
            x="0"
            y="0"
            rx="8"
            ry="8"
            width="100%"
            height="36"
            className="ml-auto"
          />
        </ContentLoader>
      </div>
    </div>
  </div>
);

export default ReserveSeatsCardSkeleton;
